<template>
    <div class="visitor-check">
        <div class="fl-container">
            <p style="margin: 20px 0">
                <b @click="showDescr = !showDescr" style="cursor: pointer; font-size: 16px; border-bottom: 2px dashed #333; font-weight: 500;">Описание</b>
                <i class="uk-icon-question-circle" style="vertical-align: top; font-size: 0.8rem; padding-left: 7px;"></i>
            </p>
            <p v-if="showDescr" style="font-size: 16px; font-weight: 400; margin: 20px 0; max-width: 960px; padding: 20px; background: #eee; border: 1px solid lightgray; border-radius: 5px;">
                <b>Среднее время проверки составляет от 10 до 15 секунд.</b>
                <br>
                Сформированный отчет будет загружен в виде файла в вашем браузере.
                <br>
                <br>
                Регламентированная проверка, позволяющая оперативно, в течение нескольких секунд, сходу отсечь наиболее проблемных "персонажей" ‑ террористов/экстремистов, лиц находящихся в розыске, предоставивших некорректные паспортные данные.
                <br>
                <br>
                <b>Типовые примеры использования:</b>
                <ul style="list-style-type: disc; width: 100%;">
                    <li>проверка посетителей</li>
                    <li>первичная проверка заявителей на предоставление услуг</li>
                </ul>
            </p>
            <div class="visitor-check-block checkbox-container">
                <div class="mobile-group">
                <div class="form-group form-group_checkbox">
                    <input v-model="checkbox.passports" type="checkbox" id="checkbox-ned-pasp" />
                    <label for="checkbox-ned-pasp" title="проверка осуществляется только по серии и номеру паспорта" class="form-group__header">Реестр недействительных паспортов ГУВМ МВД России</label>
                </div>
                <div class="form-group form-group_checkbox">
                    <input v-model="checkbox.terrorists" type="checkbox" id="checkbox-ter" />
                    <label for="checkbox-ter" class="form-group__header">Реестр террористов/экстремистов Росфинмониторинг</label>
                </div>
                </div>
                <div class="mobile-group ">
                <div class="form-group form-group_checkbox">
                    <input v-model="checkbox.rozisk" type="checkbox" id="checkbox-fed" />
                    <label for="checkbox-fed" class="form-group__header">Реестр федерального розыска МВД РФ</label>
                </div>
                <div class="form-group form-group_checkbox last-checkbox">
                    <input v-model="checkbox.fssp" type="checkbox" id="checkbox-fssp" />
                    <label for="checkbox-fssp" class="form-group__header">Реестр исполнительных производств ФССП России</label>
                </div>
                <!-- <div class="form-group form-group_checkbox">
                    <input v-model="checkbox.address" type="checkbox" id="checkbox-address">
                    <label for="checkbox-address" class="form-group__header">Проверка адреса</label>
                </div>-->
                </div>
            </div>
            <div class="visitor-check-block name-container">
                <div class="form-group form-group_inline form-group_inline-x3">
                    <div class="form-group__header">Фамилия</div>
                    <input
                        class="name-input"
                        placeholder="Фамилия"
                        v-model.trim="inputs.last_name"
                        type="text"
                        :disabled="!checkbox.fssp && !checkbox.rozisk && !checkbox.terrorists"
                    />
                </div>
                <div class="form-group form-group_inline form-group_inline-x3">
                    <div class="form-group__header">Имя</div>
                    <input
                        class="name-input"
                        placeholder="Имя"
                        v-model.trim="inputs.first_name"
                        type="text"
                        :disabled="!checkbox.fssp && !checkbox.rozisk && !checkbox.terrorists"
                    />
                </div>
                <div class="form-group form-group_inline form-group_inline-x3 fatherName-container">
                    <div class="form-group__header">Отчество</div>
                    <input
                        class="name-input"
                        placeholder="Отчество"
                        v-model.trim="inputs.patronymic"
                        type="text"
                        :disabled="!checkbox.fssp && !checkbox.rozisk && !checkbox.terrorists"
                    />
                </div>
                <div class="date-passport__container">
                    <div class="date-passport__box">
                        <div style="font-size: 14px; margin-top: 15px; margin-bottom: 5px; font-weight: 400">Дата рождения</div>
                        <div class="date-passport__holder" >
                            <div class="form-group date-part" style="margin-top: 0;">
                                <input
                                    class="date-input"
                                    style="margin-top: 0; width: 70px;"
                                    placeholder="День"
                                    @input="inputs.day = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{2})(.*)/, '$1')"
                                    v-model="inputs.day"
                                    type="text"
                                    :disabled="!checkbox.fssp && !checkbox.rozisk && !checkbox.terrorists"
                                />
                                <input
                                    class="date-input"
                                    style="margin-top: 0; width: 70px;"
                                    placeholder="Месяц"
                                    @input="inputs.month = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{2})(.*)/, '$1')"
                                    v-model="inputs.month"
                                    type="text"
                                    :disabled="!checkbox.fssp && !checkbox.rozisk && !checkbox.terrorists"
                                />
                                <input
                                    class="date-input date-year"
                                    style="margin-top: 0; width: 90px;"
                                    placeholder="Год"
                                    @input="inputs.year = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{4})(.*)/, '$1')"
                                    v-model="inputs.year"
                                    type="text"
                                    :disabled="!checkbox.fssp && !checkbox.rozisk && !checkbox.terrorists"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="date-passport__box" >
                        <div style="font-size: 14px; margin-top: 15px; margin-bottom: 5px; font-weight: 400;">Серия и номер паспорта</div>
                        <div class="date-passport__holder">
                            <div class="form-group" style="margin-top:0; margin-right: 0; display: flex;">
                                <input
                                    id="seria"
                                    placeholder="Серия"
                                    @input="inputs.passport_serial = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{4})(.*)/, '$1')"
                                    v-model="inputs.passport_serial"
                                    type="text"
                                    :disabled="!checkbox.passports"
                                />
                                <input
                                    id="number"
                                    placeholder="Номер"
                                    @input="inputs.passport_number = $event.target.value.replace(/[^0-9]/g, '').replace(/(^[0-9]{6})(.*)/, '$1')"
                                    v-model="inputs.passport_number"
                                    type="text"
                                    :disabled="!checkbox.passports"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fl-container">
            <div class="form-group button-holder">
                <button class="form-group__button form-group__button_transparent" value="Поиск" @click="() => { clearInputs() }">Очистить</button>
                <button class="form-group__button" :class="{'inactive' : getInapproval()}" :disabled="getInapproval()" value="Поиск" @click="() => { searchHandle() }" style="line-height: normal;">
                    <i v-if="loading" class="lnr lnr-sync rotating" title="Загрузка" style="font-size: 18px; display: inline-block;"></i>
                    <span v-else>Поиск</span>
                </button>
            </div>
        </div>

        <div class="fl-container">
            <div class="fz16 result" ref="result" v-if="showResults">
                <h2 style="color: #1e8bc3; font-weight: 500; font-size: 32px;">
                    <span v-if="loading">
                        <i title="Загрузка" class="lnr lnr-sync rotating" style="font-size: 22px; font-weight: bold; margin-right: 4px; display: inline-block;"></i>Загрузка...
                    </span>
                    <span v-else>Результат проверки</span>
                </h2>

                <div v-if="result.passports != null">
                    <p style="font-size: 22px" v-if="result.passports.passports == true">
                        <IconClose />
                        <b>Паспорт {{result.passports.serial}} {{result.passports.number}} входит в реестр недействительных</b>
                    </p>
                    <p style="font-size: 22px" v-else-if="result.passports.passports == false">
                        <IconCheck />
                        <b>Паспорт {{result.passports.serial}} {{result.passports.number}} отсутствует в реестре недействительных</b>
                    </p>
                </div>

                <div v-if="result.terrorists != null">
                    <div v-if="result.terrorists.terrorists.length">
                        <p style="font-size: 22px">
                            <IconClose />
                            <b>{{result.terrorists.query_param.fio}} {{formatDateFromObject(result.terrorists.query_param.date)}} находится в реестре террористов/экстремистов:</b>
                        </p>
                        <p v-for="(e, i) in result.terrorists.terrorists" :key="i">
                            <b style="font-weight: 400">{{e.fio ? `${e.fio},`: ""}} {{e.bday ? `${e.bday} гр,`: ""}} {{e.address ? e.address : ""}}</b>
                        </p>
                    </div>
                    <div v-else>
                        <p style="font-size: 22px">
                            <IconCheck />
                            <b>{{result.terrorists.query_param.fio}} {{formatDateFromObject(result.terrorists.query_param.date)}} не находится в реестре террористов/экстремистов</b>
                        </p>
                    </div>
                </div>

                <div v-if="result.rozisk != null">
                    <div v-if="result.rozisk.find_obj.length">
                        <p style="font-size: 22px">
                            <IconClose />
                            <b>{{result.rozisk.query_param.fio}} {{formatDateFromObject(result.rozisk.query_param.date)}} находится в реестре Федерального Розыска:</b>
                        </p>
                        <div v-for="(e,i) in result.rozisk.find_obj" :key="i">
                            <p style="margin: 5px 0;">
                                <img :src="e.url_img" style="width: 100px" />
                                <span style="font-weight: 400">{{e.fio}}</span>
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <p style="font-size: 22px">
                            <IconCheck />
                            <b>{{result.rozisk.query_param.fio ? `${result.rozisk.query_param.fio}`: ""}} {{formatDateFromObject(result.rozisk.query_param.date)}} не находится в реестре Федерального Розыска</b>
                        </p>
                    </div>
                </div>
                <div v-if="result.fssp != null">
                    <p style="font-size: 22px" v-if="result.fssp.ip.result.length || result.fssp.rozysk_ip.result.length || result.fssp.rozysk_yk.result.length">
                        <IconClose />
                        <b>{{result.fssp.query_param.fio}} {{formatDateFromObject(result.fssp.query_param.date)}} находится в реестре ФССП</b>
                    </p>
                    <div v-if="result.fssp.ip.result.length">
                        <p style="font-size: 18px; margin-top: 10px">
                            <b>Исполнительные производства</b>
                        </p>
                        <div v-for="(e,i) in result.fssp.ip.result" :key="i" style="font-size: 14px; margin: 10px 0">
                            <div>
                                <span v-if="e.ip_date" style="font-weight: 400">{{e.ip_date}}</span>
                                <span v-if="e.ip_number" style="font-size: 18px">{{e.ip_number}}</span>
                                <span v-if="e.date_end" style="font-weight: 400">окончено</span>
                                <span v-else-if="!e.date_end" style="font-weight: 400">открыто</span>
                            </div>
                            <div v-if="e.ip_info">
                                <b>Предмет исполнения:</b>
                                <span>{{e.ip_info}}</span>
                            </div>
                            <div v-if="e.otdel_fssp">
                                <b>Адрес отдела:</b>
                                <span>{{e.otdel_fssp}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="result.fssp.rozysk_ip.result.length">
                        <p style="font-size: 18px; margin-top: 10px">
                            <b>Розыск по исполнительным производствам</b>
                        </p>
                        <div v-for="(e,i) in result.fssp.rozysk_ip.result" :key="i" style="font-size: 14px; margin: 10px 0">
                            <div>
                                <span v-if="e.ip_date" style="font-weight: 400">{{e.ip_date}}</span>
                                <span v-if="e.ip_number" style="font-size: 18px">{{e.ip_number}}</span>
                            </div>
                            <div v-if="e.delo_number">
                                <b>Номер дела:</b>
                                <span>{{e.delo_number}}</span>
                            </div>
                            <div v-if="e.otdel_fssp">
                                <b>Адрес отдела:</b>
                                <span>{{e.otdel_fssp}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="result.fssp.rozysk_yk.result.length">
                        <p style="font-size: 18px; margin-top: 10px">
                            <b>Подозрение в совершении преступлений</b>
                        </p>
                        <div v-for="(e,i) in result.fssp.rozysk_yk.result" :key="i" style="font-size: 14px; margin: 10px 0">
                            <div>
                                <b>Адрес проживания:</b>
                                <span>{{e.address}}</span>
                            </div>
                            <div>
                                <b>Орган инициировавший розыск:</b>
                                <span>{{e.name_org_initiating}}</span>
                            </div>
                            <div>
                                <b>Орган осуществляющий розыск:</b>
                                <span>{{e.name_org_initiates}}</span>
                            </div>
                            <div>
                                <b>Статья:</b>
                                <span>{{e.statya}}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="result.fssp.ip.result.length == 0 && result.fssp.rozysk_ip.result.length == 0 && result.fssp.rozysk_yk.result.length == 0">
                        <p style="font-size: 22px">
                            <IconCheck />
                            <b>{{result.fssp.query_param.fio ? `${result.fssp.query_param.fio}`: ""}} {{formatDateFromObject(result.fssp.query_param.date)}} не находится в реестре ФССП</b>
                        </p>
                    </div>
                </div>
            </div>
            <button v-if="showResults" @click="saveResultPDF" class="form-group__button" style="margin-top: 10px" >Скачать .pdf</button>
        </div>

        <div class="fl-container container__history">
            <h2 style="color: #1e8bc3; font-weight: 500; font-size: 32px">История проверок</h2>
            <adminFilters v-if="admin" :adminType="'check_visitor'" :onFilterCallback="getHistory" @admin-request="adminRequest" @history-refresh="historyRefresh"/>

            <dropDownButton title="Скачать в .xlsx" :items="['Первые 5000 записей', 'Текущую страницу']" :onSelect="downloadXLSX" />

            <pagination v-if="history.pagination && history.items.length" :pagination="history.pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.items.length" />

            <table style="font-size: 16px; margin-top: 25px; width: 100%;" class="content-table">
                <tr>
                    <th id="date">Дата и время</th>
                    <th v-if="admin">Пользователь</th>
                    <th>Реестры</th>
                    <th>Результат проверки</th>
                </tr>
                <tr v-for="(e,i) in history.items" :key="i" style="font-size: 14px;">
                    <td id="time">{{new Date(e.query_param.date_of_visitor).toLocaleDateString()}} {{getHoursAndMinutesFomDateObjectString(e.query_param.date_of_visitor)}}</td>
                    <td v-if="admin">{{e.user_name}}<br>{{e.user_login ? `(${e.user_login})` : "" }}</td>
                    <td>
                        {{Object.keys(e.check_result).join(', ')
                            .replace('terrorists', "Терр./Экстр.")
                            .replace('passports', "Паспорт")
                            .replace('fed_rozysk', "Фед. Розыск")
                            .replace('fssp_fl', "ФССП")
                        }}
                    </td>
                    <td @click="() => { modal_show = true; modal = { check_result: e.check_result, fio: e.query_param.fio, date: e.query_param.date, dateCheck: new Date(e.query_param.date_of_visitor).toLocaleDateString() } }" style="cursor: pointer">
                        <IconClose v-if="
                            (e.check_result.terrorists && e.check_result.terrorists.length) ||
                            (e.check_result.passports && e.check_result.passports.result) ||
                            (e.check_result.fed_rozysk && e.check_result.fed_rozysk.length) ||
                            (e.check_result.fssp_fl && (e.check_result.fssp_fl.ip.result.length || e.check_result.fssp_fl.rozysk_ip.result.length || e.check_result.fssp_fl.rozysk_yk.result.length))"/>
                        <IconCheck v-else />
                        <span style="color: #5F83F4" v-if="e.check_result.passports && e.check_result.passports.serial && e.check_result.passports.number">
                            {{e.check_result.passports.serial}} {{e.check_result.passports.number}} 
                        </span>
                        <span style="color: #5F83F4" v-if="e.query_param.fio">
                            {{e.query_param.fio}}
                        </span>
                        <span style="color: #5F83F4" v-if="e.query_param.date && Object.values(e.query_param.date).join('')">
                            {{formatDateFromObject(e.query_param.date)}}
                        </span>
                    </td>
                </tr>
            </table>

            <pagination v-if="history.pagination && history.items.length" :pagination="history.pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.items.length" />

            <modal v-if="modal_show" :close="() => { modal_show = false }" :printButton="true" :downloadButton="true">
                <h2 slot="modalHeader" style="color: #1e8bc3; font-weight: 500; font-size: 25px;">Результат проверки {{modal.dateCheck}}</h2>
                <div slot="modalBody" style="padding: 15px">
                    <div v-if="modal.check_result.passports != null" stlye="margin: 0 0 15px;">
                        <p style="font-size: 22px" v-if="modal.check_result.passports.result == true">
                            <IconClose />
                            <b>Паспорт {{modal.check_result.passports.serial}} {{modal.check_result.passports.number}} входит в реестр недействительных</b>
                        </p>
                        <p style="font-size: 22px" v-else-if="modal.check_result.passports.result == false">
                            <IconCheck />
                            <b>Паспорт {{modal.check_result.passports.serial}} {{modal.check_result.passports.number}} отсутствует в реестре недействительных</b>
                        </p>
                    </div>

                    <div v-if="modal.check_result.terrorists != null" style="margin: 0 0 15px;">
                        <div v-if="modal.check_result.terrorists.length">
                            <p style="font-size: 22px; margin: 0;">
                                <IconClose />
                                <b>{{modal.fio}} {{formatDateFromObject(modal.date)}} находится в реестре террористов/экстремистов:</b>
                            </p>
                            <p v-for="(e, i) in modal.check_result.terrorists" :key="i" style="font-weight: 500; margin: 0;">
                                <span style="font-weight: 400">{{e.fio ? `${e.fio},`: ""}} {{e.bday ? `${e.bday} гр,`: ""}} {{e.address ? e.address : ""}}</span>
                            </p>
                        </div>
                        <div v-else>
                            <p style="font-size: 22px">
                                <IconCheck />
                                <b>{{modal.fio}} {{formatDateFromObject(modal.date)}} не находится в реестре террористов/экстремистов</b>
                            </p>
                        </div>
                    </div>

                    <div v-if="modal.check_result.fed_rozysk != null">
                        <div v-if="modal.check_result.fed_rozysk.length">
                            <p style="font-size: 22px">
                                <IconClose />
                                <b>{{modal.fio}} {{formatDateFromObject(modal.date)}} находится в реестре Федерального Розыска:</b>
                            </p>
                            <div v-for="(e,i) in modal.check_result.fed_rozysk" :key="i">
                                <p style="margin: 5px 0;">
                                    <img :src="e.url_img" style="width: 100px" />
                                    <span style="font-weight: 400">{{e.fio}}</span>
                                </p>
                            </div>
                        </div>
                        <div v-else>
                            <p style="font-size: 22px">
                                <IconCheck />
                                <b>{{modal.fio}} {{formatDateFromObject(modal.date)}} не находится в реестре Федерального Розыска</b>
                            </p>
                        </div>
                    </div>

                    <div v-if="modal.check_result.fssp_fl != null">
                        <p style="font-size: 22px" v-if="modal.check_result.fssp_fl.ip.result.length || modal.check_result.fssp_fl.rozysk_ip.result.length || modal.check_result.fssp_fl.rozysk_yk.result.length">
                            <IconClose />
                            <b>{{modal.fio}} {{formatDateFromObject(modal.date)}} находится в реестре ФССП</b>
                        </p>
                        <div v-if="modal.check_result.fssp_fl.ip.result.length">
                            <p style="font-size: 18px; margin-top: 10px">
                                <b>Исполнительные производства</b>
                            </p>
                            <div v-for="(e,i) in modal.check_result.fssp_fl.ip.result" :key="i" style="font-size: 14px; margin: 10px 0">
                                <div>
                                    <span v-if="e.ip_date" style="font-weight: 400">{{e.ip_date}}</span>
                                    <span v-if="e.ip_number" style="font-size: 18px">{{e.ip_number}}</span>
                                    <span v-if="e.date_end" style="font-weight: 400">окончено</span>
                                    <span v-else-if="!e.date_end" style="font-weight: 400">открыто</span>
                                </div>
                                <div v-if="e.ip_info">
                                    <b>Предмет исполнения:</b>
                                    <span>{{e.ip_info}}</span>
                                </div>
                                <div v-if="e.otdel_fssp">
                                    <b>Адрес отдела:</b>
                                    <span>{{e.otdel_fssp}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="modal.check_result.fssp_fl.rozysk_ip.result.length">
                            <p style="font-size: 18px; margin-top: 10px">
                                <b>Розыск по исполнительным производствам</b>
                            </p>
                            <div v-for="(e,i) in modal.check_result.fssp_fl.rozysk_ip.result" :key="i" style="font-size: 14px; margin: 10px 0">
                                <div>
                                    <span v-if="e.ip_date" style="font-weight: 400">{{e.ip_date}}</span>
                                    <span v-if="e.ip_number" style="font-size: 18px">{{e.ip_number}}</span>
                                </div>
                                <div v-if="e.delo_number">
                                    <b>Номер дела:</b>
                                    <span>{{e.delo_number}}</span>
                                </div>
                                <div v-if="e.otdel_fssp">
                                    <b>Адрес отдела:</b>
                                    <span>{{e.otdel_fssp}}</span>
                                </div>
                            </div>
                        </div>

                        <div v-if="modal.check_result.fssp_fl.rozysk_yk.result.length">
                            <p style="font-size: 18px; margin-top: 10px">
                                <b>Подозрение в совершении преступлений</b>
                            </p>
                            <div v-for="(e,i) in modal.check_result.fssp_fl.rozysk_yk.result" :key="i" style="font-size: 14px; margin: 10px 0">
                                <div>
                                    <b>Адрес проживания:</b>
                                    <span>{{e.address}}</span>
                                </div>
                                <div>
                                    <b>Орган инициировавший розыск:</b>
                                    <span>{{e.name_org_initiating}}</span>
                                </div>
                                <div>
                                    <b>Орган осуществляющий розыск:</b>
                                    <span>{{e.name_org_initiates}}</span>
                                </div>
                                <div>
                                    <b>Статья:</b>
                                    <span>{{e.statya}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="modal.check_result.fssp_fl.ip.result.length == 0 && modal.check_result.fssp_fl.rozysk_ip.result.length == 0 && modal.check_result.fssp_fl.rozysk_yk.result.length == 0">
                            <p style="font-size: 22px">
                                <IconCheck />
                                <b>{{modal.fio ? `${modal.fio}`: ""}} {{formatDateFromObject(modal.date)}} не находится в реестре ФССП</b>
                            </p>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import uuid from "uuid/v1"
import modal from "@/components/ui/modal.vue"
import pagination from '@/components/ui/pagination.vue'
import adminFilters from '@/components/ui/adminFilters.vue'
import { htmlStringToPrint, downloadBinaryFile } from '@/helpers'
import dropDownButton from '@/components/ui/dropDownButton.vue'

const IconClose = () => <i class="uk-icon-close" style="color: #e74c3c"></i>
const IconCheck = () => <i class="uk-icon-check" style="color: #2ecc71"></i>

const result = () => ({
    passports: null,
    terrorists: null,
    address: null,
    fssp: null,
    rozisk: null,
})

const checkbox = () => ({
    passports: true,
    terrorists: true,
    rozisk: false,
    fssp: false,
    address: false,
})

const inputs = () => ({
    first_name: "",
    last_name: "",
    patronymic: "",
    day: "",
    month: "",
    year: "",
    address: "",
    inn: "",
    passport_serial: "",
    passport_number: "",
    company_name: "",
    region: 77,
})

export default {
    components: {
        modal,
        IconClose,
        IconCheck,
        pagination,
        dropDownButton,
        adminFilters
    },
    data() {
        return {
            result: result(),
            checkbox: checkbox(),
            inputs: inputs(),
            loading: false,
            showDescr: false,
            history: {
                items: [],
                pagination: {},
                searchQuery: '',
                users: [],
                date_from: '',
                date_to: '',
            },
            alexnderCheckbox: true,
            modal_show: false,
            modal: {}
        }
    },
    computed: {
        admin() { return this.$store.state.user?.groups?.filter(e => e.rules.adm_check_fl)?.length },
        passport_number_validated: {
            get() {
                return this.passport_number
            },
            set(v) {
                this.passport_number = v
                    .replace(/[^0-9]/g, "")
                    .replace(/^([0-9]{6})(.*)/, "$1")
            },
        },
        showResults() {
            return (
                this.result.passports != null ||
                this.result.terrorists != null ||
                this.result.rozisk != null ||
                this.result.fssp != null
            )
        },
    },
    mounted() {
        this.getHistory()
    },
    methods: {
        downloadXLSX(item){
            const downloadFileInsideThenFn = res => {
                downloadBinaryFile(res.data, `История запросов ${new Date().toLocaleDateString()}`, 'xlsx')
                this.downloadLoading = false
            }

            let limit, offset

            this.downloadLoading = true

            if(item == 'Первые 5000 записей') {
                limit = 5000
                offset = 0
            } else if(item == 'Текущую страницу') {
                limit = this.history.pagination.rows_per_page
                offset = limit * (this.history.pagination.current_page - 1)
            }

            this.$store.dispatch("RomAPI", {
                method: "check_fl",
                responseType: 'arraybuffer',
                out_format: "xlsx",
                data: {
                    action: "history",
                    searchName: this.history.searchQuery,
                    filterUsers: this.history.users,
                    dateFrom: this.history.date_from,
                    dateTo: this.history.date_to,
                    show_adm: this.checkbox,
                    offset,
                    limit
                }
            })
                .then(downloadFileInsideThenFn)
                .finally(this.finishDownload)
        },
        adminRequest(value){
            this.alexnderCheckbox = value
            console.log(this.alexnderCheckbox)
        },
        formatDateFromObject(date) {
            if (date && Object.values(date).join("").length) {
                const day = date.day ? `${date.day}.` : ""
                const month = date.month ? `${date.month}.` : ""
                const year = date.year ? `${date.year}` : ""
                return day + month + year + " г.р."
            } else {
                return ""
            }
        },
        getHistory(
            offset = 0,
            limit = 50,
            searchQuery = this.history.searchQuery,
            users = this.history.users,
            date_from = this.history.date_from,
            date_to = this.history.date_to
        ) {
            this.loading = true
            this.history = {
                ...this.history,
                searchQuery,
                users,
                date_from,
                date_to
            }
            this.$store.dispatch("RomAPI", {
                method: "check_fl",
                data: {
                    action: "history",
                    filterUsers: users,
                    searchFIO: searchQuery,
                    dateFrom: date_from,
                    dateTo: date_to,
                    show_adm: this.alexnderCheckbox,
                    offset,
                    limit
                },
            }).then(e => {
                if (e.data.data && e.data.data.list_history_fl && e.data.data.list_history_fl.length) {
                    this.history.items = e.data.data.list_history_fl
                    this.history.pagination = e.data.data.pagination
                    this.history.items.sort((a, b) => {
                        if (a.number_request * 1 < b.number_request * 1) {
                            return 1
                        } else if(a.number_request * 1 > b.number_request * 1) {
                            return -1
                        } else {
                            return 0
                        }
                    })
                } else if(e.data.data.list_history_fl.length == 0) {
                    this.history.items = []
                    this.history.pagination = {}
                }
            }).finally(() => {
                this.loading = false
            })
        },
        saveResultPDF() {
            const imgHtmlCode = htmlStringToPrint('', this.$refs.result.outerHTML)

            this.$store.dispatch('flCheck/getPdf', {
                imgHtmlCode,
                filename: 'rezultat_proverki'
            })
        },
        clearAddressSuggestions() {
            this.dadata_address_suggestions = []
        },
        clearInputs() {
            Object.keys(this.inputs).forEach(e => {
                this.dadata_address_value = null
                if (e != "region") {
                    this.inputs[e] = ""
                }
            })
        },
        searchHandle() {
            // TODO "валидация формы"

            const id = uuid()
            this.result = result()

            Promise.all([
                this.getPassports(id),
                this.getTerrorists(id),
                this.getFSSP(id),
                this.getFedRosisk(id),
            ]).then(() => {
                this.getHistory()
                this.loading = false
            })
        },
        inputAddress(evt) {
            clearTimeout(this.dadata_address_timeout)

            this.dadata_address_timeout = setTimeout(() => {
                this.getAddress(evt.target.value)
            }, 500)
        },
        getFSSP(id) {
            if (this.checkbox.fssp) {
                if (this.inputs.last_name) {
                    if (this.inputs.last_name) {
                        if (this.inputs.patronymic) {
                            if (this.inputs.day && this.inputs.month && this.inputs.year) {
                                this.loading = true
                                return this.$store.dispatch("RomAPI", {
                                    method: "fssp_fl",
                                    data: {
                                        id,
                                        firstname: this.inputs.first_name,
                                        lastname: this.inputs.last_name,
                                        secondname: this.inputs.patronymic,
                                        day: this.inputs.day,
                                        month: this.inputs.month,
                                        year: this.inputs.year,
                                    },
                                }).then(e => {
                                    if (e) {
                                        this.result.fssp = e.data.data
                                    }
                                })
                            } else {
                                this.$store.dispatch("showErrorPopUp", "Не введена дата рождения для проверки ФССП")
                            }
                        } else {
                            this.$store.dispatch("showErrorPopUp", "Не введено отчество для проверки ФССП")
                        }
                    } else {
                        this.$store.dispatch("showErrorPopUp", "Не введено имя для проверки ФССП")
                    }
                } else {
                    this.$store.dispatch("showErrorPopUp", "Не введена фамилия для проверки ФССП")
                }
            }
        },
        getPassports(id) {
            if (this.checkbox.passports) {
                if (this.inputs.passport_serial && this.inputs.passport_number) {
                    const is_anything_checked_besides_passports = Object.values(this.checkbox).filter(Boolean).length > 1
                    this.loading = true
                    return this.$store.dispatch("RomAPI", {
                        method: "passports",
                        data: {
                            // id: is_anything_checked_besides_passports ? id : "",
                            id,
                            serial: this.inputs.passport_serial,
                            number: this.inputs.passport_number,
                        },
                    }).then(e => {
                        if (e.data.data) {
                            this.result.passports = e.data.data
                        }
                    })
                } else {
                    this.$store.dispatch("showErrorPopUp", "Не введена серия или номер паспорта для проверки недействительных паспортов")
                }
            }
        },
        getTerrorists(id) {
            if (this.checkbox.terrorists) {
                if (this.inputs.last_name || this.inputs.first_name || this.inputs.patronymic) {
                    this.loading = true
                    return this.$store.dispatch("RomAPI", {
                        method: "terrorists",
                        data: {
                            id,
                            lastname: this.inputs.last_name,
                            firstname: this.inputs.first_name,
                            secondname: this.inputs.patronymic,
                            day: this.inputs.day,
                            month: this.inputs.month,
                            year: this.inputs.year,
                        },
                    }).then(e => {
                        if (e.data.data) {
                            this.result.terrorists = e.data.data
                        }
                    })
                } else {
                    this.$store.dispatch("showErrorPopUp", "Не введено ФИО для проверки по реестру террористов")
                }
            }
        },
        getFedRosisk(id) {
            if (this.checkbox.rozisk) {
                if (this.inputs.last_name) {
                    if (this.inputs.first_name) {
                        if (this.inputs.year) {
                            this.loading = true
                            return this.$store.dispatch("RomAPI", {
                                method: "fed_rozysk",
                                data: {
                                    id,
                                    lastname: this.inputs.last_name,
                                    firstname: this.inputs.first_name,
                                    secondname: this.inputs.patronymic,
                                    day: this.inputs.day,
                                    month: this.inputs.month,
                                    year: this.inputs.year,
                                },
                            }).then(e => {
                                if (e.data.data && e.data.data.find_obj) {
                                    this.result.rozisk = e.data.data
                                }
                            })
                        } else {
                            this.$store.dispatch("showErrorPopUp", "Не введен ГОД для проверки по реестру Федерального Розыска")
                        }
                    } else {
                        this.$store.dispatch("showErrorPopUp", "Не введено ИМЯ для проверки по реестру Федерального Розыска")
                    }
                } else {
                    this.$store.dispatch("showErrorPopUp", "Не введена ФАМИЛИЯ для проверки по реестру Федерального Розыска")
                }
            }
        },
        getInapproval() {
            const isFioChecked = this.checkbox.rozisk || this.checkbox.fssp || this.checkbox.terrorists
            const isPassportChecked = this.checkbox.passports
            let fioStatus = false
            let passportStatus = false
            let isDisabled = true
            
            if(isPassportChecked && this.inputs.passport_serial && this.inputs.passport_number) { passportStatus = true }
            if(isFioChecked && this.inputs.first_name && this.inputs.last_name && this.inputs.patronymic) { fioStatus = true }
            if(isFioChecked && isPassportChecked && fioStatus && passportStatus) { isDisabled = false }
            if(isFioChecked && fioStatus && !isPassportChecked) { isDisabled = false }
            if(isPassportChecked && passportStatus && !isFioChecked) { isDisabled = false }

            return isDisabled
        },
        historyRefresh() {
            this.history.searchQuery = ''
            this.history.users = ''
            this.history.date_from = ''
            this.history.date_to = ''
            this.getHistory()
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

#group-select
    width: 360px

#user-select
    width: 552px

.table-column
    padding-left: 10px !important

.search-header
    padding-top: 15px
    font-size: 14px
    font-weight: 500

.button-row
    margin-left: 80.85%

.filter-separator
    padding-top: 5px
    font-weight: 300
    color: #b8b8b8

.date-description
    margin-left: 0 !important

.group-description
    margin-left: 220px !important

.user-description
    margin-left: 188px !important

.last-row
   margin-bottom: 30px !important

.filter-row
    display: flex
    margin: 10px 0

.date-filter__holder
    display: flex

.refresh__button
    display: inline-block
    vertical-align: top
    text-align: center
    font-weight: 500
    font-size: 14px
    color: #333
    background:transparent
    border: 0
    border-radius: 5px
    cursor: pointer
    margin: 0 5px 0 15px
    width: 112px
    height: 34px
    line-height: 34px

.refresh__button:active
    color: #484747
    background-color: #a7baf9
.lnr-cross
    cursor: pointer
    position: absolute
    right: 15px
    font-size: 26px
    bottom: 25px
.visitor-check .form-group__button_transparent:active
    color: #484747
    background-color: #a7baf9
.visitor-check .form-group__button.inactive
    opacity: 0.5
    cursor: not-allowed
#group-filter 
    margin-left: 15px
#user-filter
    margin-left: 15px
.filter-table
    width: 100%

.filter-header 
    padding-top: 8px
    font-size: 14px
    font-weight: 500

.filter-description
    font-size: 14px
    padding-top: 8px
    margin: 0 25px
    font-weight: 400

.type
    height: 30px !important

.filter-input
    width: 165px
    margin-bottom: 5px
    min-height: 30px
    border-radius: 3px
    padding: 4px 8px
    border: 1px solid #b8b8b8
    box-shadow: none
    text-align: left
.add-select 
    width: 399.3px
    border: 1px solid #b8b8b8
    border-radius: 4px
    font-size: 14px

.add-select 
    option
        font-size: 14px

.monitoring__content-search-block
    width: 100%
    position: relative

.monitoring__content-search
    margin-top: 15px
    margin-bottom: 15px
    background: rgba(173, 203, 252, 0.46)
    width: 100%
    height: 46px
    line-height: 46px
    border-radius: 6px
    border: 0
    padding: 0 20px

.filters-holder
    float: right
    display: block
    margin: 20px 170px 0 0

.filters-holder button
    margin: 10px 0 0 0

.date-passport__holder
    display: flex

.date-passport__container
    display: flex

.date-passport__box
    display: flex
    flex-direction: column 

.name-input
    width: 203.5px !important

.button-holder
    text-align: right !important
    margin-right: 0 !important

.date-input
    width: 70px !important
    margin-top: 0

.date-year
    width: 90px !important

.uk-icon-check, .uk-icon-close
    width: 22px

#seria
    width: 145px
    margin-right: 5px

#number
    width: 211px

#date
    width: 150px

.visitor-check
    h2
        @include page-heading
    .form-group
        @include form-group
        margin-right: 15px
    .fl-container
        font-size: 0
        &__history
            margin-top: 40px
    &-block
        vertical-align: top
        font-size: 0
        margin-top: 20px
        width: 50%
        display: inline-block
        &:first-child
            padding-right: 25px
        &:last-child
            padding-left: 25px
    .result
        margin: 10px auto
        p
            margin: 0
        > div
            margin: 10px auto
        table
            tr
                th
                    font-weight: 500
                td
                    font-size: 14px
                    font-weight: 400
                th, td
                    text-align: left
                    padding: 0 10px

@media screen and (max-width: 1280px)
    #group-select
        width: 265px
    #user-select
        width: 390px
    .button-holder
        text-align: right !important
        margin-right: 0 !important
    .name-input
        width: 160.5px !important
    .fatherName-container
        margin-right:0 !important
    .date-input
        width: 60px !important
    .date-year
        width: 70px !important
    #seria
        width: 100px !important
    #number
        width: 168px !important
        .table-column
        padding-left: 10px !important

    .search-header
        padding-top: 15px
        font-size: 14px
        font-weight: 500

    .button-row
        margin-left: 76%

    .filter-separator
        padding-top: 5px
        font-weight: 300
        color: #b8b8b8
    .group-description
        margin-left: 222px !important

    .user-description
        margin-left: 91px !important

    .last-row
        margin-bottom: 30px !important

    .filter-row
        display: flex
        margin: 10px 0
    .lnr-cross
        cursor: pointer
        position: absolute
        right: 15px
        font-size: 26px
        bottom: 25px

    #group-filter 
        margin-left: 15px

    #user-filter
        margin-left: 15px

    .filter-table
        width: 100%

    .filter-header 
        padding-top: 8px
        font-size: 14px
        font-weight: 500

    .filter-description
        font-size: 14px
        padding-top: 8px
        margin: 0 25px
        font-weight: 400
    .add-select 
        width: 315px
        border: 1px solid #b8b8b8
        border-radius: 4px
        font-size: 14px
    .add-select 
        option
            font-size: 14px

@media screen and (max-width: 1024px)
    .name-input
        width: 149.5px !important
    input::placeholder
        font-size: 12px !important
    .date-input
        width: 60px !important
    .date-year
        width: 70px !important
    #seria
        width: 92px !important
    #number
        width: 142px !important

@media screen and (max-width: 960px)
    .name-input
        width: 118px !important
    input::placeholder
        font-size: 11px !important
    .date-input
        width: 51px !important
    .date-year
        width: 53px !important
    #seria
        width: 70px !important
    #number
        width: 102px !important
@media screen and (max-width: 767px)
    input::placeholder
        font-size: 14px !important
    .visitor-check-block
        width: 100% !important
        padding: 0 !important
    .name-input
        width: 156.3px !important
    label, td, th
        font-size: 12px !important
    .checkbox-container
        display: flex
    .date-input
        width: 60px !important
    .date-year
        width: 70px !important
    #seria
        width: 100px !important
    #number
        width: 159px !important
    .mobile-group
        display: flex
@media screen and (max-width: 480px)
    #seria
        width: 100px !important
    #number
        width: 135px !important
    .button-holder
        text-align: center !important
    .date-input
        width: 70px !important
    .date-year
        width: 90px	!important
    .fl-container
        text-align: center
    .mobile-group
        flex-direction: column 
    .name-container
        display: flex
        flex-direction: column
        justify-content: center !important
    .name-input
        width: 240px !important
    .form-group_inline-x3
        width: 100% !important
    .date-passport__container
        flex-direction: column
        justify-content: center !important
    .date-passport__box
        justify-content: center !important
    .date-passport__holder
        justify-content: center !important
    .form-group_checkbox
        text-align: left
    .date-part
        margin-right: 0 !important
</style>